import React, { useState, useEffect, useRef } from "react";
import { Carousel } from "antd"; // Import Carousel from antd
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "../../styles/NewHome.css"; // Assuming the CSS file is in the same directory
import decoy from "../../images/main-logo.png";
import SignIn from "../SignIn";
import wordcloud from "../../images/wrd.png";
import wide from "../../images/cdac-logo-wide.png";
import social from "../../images/kindpng_1449395.png";
import sm from "../../images/kindpng_1449468.png";
import { useNavigate } from "react-router-dom";

const DecoyHomePage = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesRef = useRef(null);

  const sliderContent = [
    {
      title: "Welcome to C-SMART",
      content:
        "Our project is dedicated to providing you with powerful insights and analytics across various social media platforms. With our innovative tool, you can gain comprehensive understanding and analysis of your social media presence, all in one place.",
      sliderImg: decoy, // Using placeholder images
    },
    {
      title: "Unlock the Power of C-SMART",
      content:
        "Our project is dedicated to providing you with powerful insights and analytics across various social media platforms. With our innovative tool, you can gain comprehensive understanding and analysis of your social media presence, all in one place.",
      sliderImg: wordcloud,
    },
    {
      title: "Harness Insights with C-SMART",
      content:
        "Gain valuable insights into audience engagement, content performance, and trending topics across all your social media channels.",
      sliderImg: social,
    },
    {
      title: "Empower Your Strategy with C-SMART",
      content:
        "Our intuitive dashboard empowers you to make informed decisions, optimize your strategy, and maximize your online presence with ease. From monitoring key metrics to identifying emerging trends, C-SMART equips you with the tools you need to stay competitive in the dynamic world of social media marketing.",
      sliderImg: sm,
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === sliderContent.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? sliderContent.length - 1 : prev - 1
    );
  };

  // Auto-advance the slides every 5 seconds
  React.useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="diginyay-container">
      <header className="diginyay-header">
        <div className="diginyay-logo-container">
          <img src={wide} alt="C-SMART Logo" className="diginyay-logo" />
          {/* <h1 className="diginyay-logo-text">DIGIN<span>YAY</span></h1> */}
        </div>
        <nav className="diginyay-nav">
          <button
            className="diginyay-login-button"
            onClick={() => navigate("/")}
          >
            Login
          </button>
        </nav>
      </header>

      <main className="diginyay-main">
        <div className="diginyay-hero">
          <div className="diginyay-carousel-container" ref={slidesRef}>
            {sliderContent.map((item, index) => (
              <div
                key={index}
                className={`diginyay-slide ${
                  index === currentSlide ? "active" : ""
                }`}
              >
                <div className="diginyay-slide-content">
                  <div className="diginyay-slide-text">
                    <h2 className="diginyay-slide-title">{item.title}</h2>
                    <div className="diginyay-slide-divider"></div>
                    <p className="diginyay-slide-description">{item.content}</p>
                    {/* <button className="diginyay-cta-button">Get Started</button> */}
                  </div>
                  <div className="diginyay-slide-image">
                    <img
                      src={item.sliderImg}
                      alt="C-SMART Feature"
                      className="diginyay-feature-image"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="diginyay-carousel-indicators">
            {sliderContent.map((_, index) => (
              <button
                key={index}
                className={`diginyay-indicator ${
                  index === currentSlide ? "active" : ""
                }`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              ></button>
            ))}
          </div>

          <div className="diginyay-carousel-controls">
            <button
              onClick={prevSlide}
              className="diginyay-carousel-button diginyay-prev"
              aria-label="Previous slide"
            >
              <FontAwesomeIcon icon={faChevronLeft} size="xs" />
            </button>
            <button
              onClick={nextSlide}
              className="diginyay-carousel-button diginyay-next"
              aria-label="Next slide"
            >
              <FontAwesomeIcon icon={faChevronRight} size="xs" />
            </button>
          </div>
        </div>
      </main>

      <div className="diginyay-footer-text">
        <div>
          <p>Copyright © 2025</p>
          <br />
          <p>Designed and Developed by CDAC</p>
        </div>
        {/* <div className="diginyay-footer-links">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Contact Us</a>
        </div> */}
      </div>
    </div>
  );
};

export default DecoyHomePage;
